import React, {Fragment} from "react";
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";

import {setCookieAccepted, toggleUserPopup} from "../../actions/actionFunctions";
import {setSessionStorageItem} from "../../misc/storageFunctions";

class CookieMessage extends React.Component {

  cookieElement = null;

  componentDidMount() {
    if (this.props.fabricatorData.received) {
      this.checkToDisplayCookie(this.props.fabricatorData.settings.enableCookiePopup);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.fabricatorData.received && !this.props.fabricatorData.received) {
      this.checkToDisplayCookie(nextProps.fabricatorData.settings.enableCookiePopup);
    }
  }

  checkToDisplayCookie = (enableCookiePopup) => {
    try {
      if (window.sessionStorage.getItem("cookieAccepted") || document.kvConfig.jobId || !enableCookiePopup) {
        this.props.setCookieAccepted(true);
      } else {
        setTimeout(() => {
          this.cookieElement.classList.remove("cookie--accepted");
        }, 1000);
      }
    } catch (ex) { console.log(ex); }
  };

  handleAcceptButtonClick = () => {
    this.cookieElement.classList.add("cookie--accepted");
    setSessionStorageItem("cookieAccepted", true);
    setTimeout(() => {
      this.props.setCookieAccepted(true);
    }, 350);
  };

  handlePrivacyPolicyClick = () => {
    this.props.toggleUserPopup({
      userPopupOpened: true,
      showPrivacyPolicy: true
    });
    setTimeout(() => {
      if (window.anchorScroll) {
        window.anchorScroll("cookie");
      }
    }, 500)
  };

  getCookieMessage = () => {
    // return `This website uses 'cookies' to give you the best, most relevant experience.
    //       Using this website means you're Ok with this. You can change which cookies are set at any time - and find
    //       out more about them - by following this <span className="cookie-text__link bold">link</span> (or by clicking the cookie link at the top of any page). `
    return (
      <Fragment>
        <p><FormattedMessage id="cookie.text1"/></p>
        <p><FormattedMessage id="cookie.text2"/></p>
        <p><FormattedMessage id="cookie.text3"/></p>
      </Fragment>
    )
  };

  render() {
    return this.props.cookieAccepted ? null : (
      <div className="cookie cookie--accepted" ref={(node) => this.cookieElement = node}>
        <div className="cookie-text">{this.getCookieMessage()}</div>
        <div className="cookie-button">
          <span className="cookie-button__link bold" onClick={this.handlePrivacyPolicyClick}>
            <FormattedMessage id="cookie.policyLink"/>
          </span>
          <button className="ui-button2 ui-button2--white" onClick={this.handleAcceptButtonClick}>
            <FormattedMessage id="cookie.acceptButton"/>
          </button>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (store) => {
  return {
    cookieAccepted: store.serverState.cookieAccepted,
    fabricatorData: store.fabricatorState,
  };
};

export default connect(mapStateToProps, {
  setCookieAccepted,
  toggleUserPopup
})(CookieMessage);
